import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

  container: ({ marginTop }) => {
    return {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: marginTop,
    }
  },

  avatarIcon: {
    padding: '11px',
    // border: '1px #e5e5e5 solid',
    backgroundColor: '#fff',

    '& img': {
      maxHeight: '48px',
      objectFit: 'contain',
    }
  },

  clientAvatarIcon: ({ isOauthFailing, clientLogoURL }) => {
    // Workaround: when the ECAL default logo is reused as the client logo, upsize it so it matches the widget logo's visual weight.
    function getLogoSize () {
      if (clientLogoURL?.includes('assets/app/logo-round-white-circle.svg')) {
        return {
          maxHeight: '70px',
          height: '70px',
          width: '70px' 
        };
      }

      return { maxHeight: '48px' }
    }

    return {
      marginLeft: isOauthFailing && '-8px',

      '& img': {
        ...getLogoSize(),
        objectFit: 'contain',
      },
    };
  },

  loadingIconStyling: ({ marginInBetween }) => {
    return {
      margin: `0px ${marginInBetween}`,
      width: '200px',
      height: '100px',
    }
  },

});

export default styles;
export const useStyles = makeStyles(styles);
